import React from 'react';
import './Commontabl.css';



const Commontabl = () => {
    return (
        <div className="mold-container">
            <h2 className="heading">Disha PET Preforms Injection Molding Production</h2>
            <p><strong>Case for reference:</strong></p>
            <div className="details-grid">
                <div className="left-column">
                    <p><strong>Machine Model</strong> </p>
                    <p><strong>Product</strong> </p>
                    <p><strong>Mold Cavity</strong> </p>
                    <p><strong>Weight</strong></p>
                    <p><strong>Cycle Time</strong></p>

                </div>
                <div className="right-column">
                    <p>KPET2100-E6</p>
                    <p>	PET Preform</p>
                    <p>	64 Cavities</p>
                    <p> 12.7g</p>
                    <p>	12s</p>

                </div>
            </div>
        </div>
    );
};

export default Commontabl;
